import React from "react";

export const getFieldError = (errors = {}, field) => {
  const messages = errors?.[field];

  return Array.isArray(messages) && messages.length > 0 ? messages[0] : "";
};

export const inputErrorClass = (errors = {}, field) => getFieldError(errors, field) ? "has-error" : "";

export const FieldError = ({ errors = {}, name }) => {
  const message = getFieldError(errors, name);

  if (!message) return null;

  return <span className="epic-field-error">{message}</span>;
};

const FormFeedback = ({ success, error, validationErrors = [], title = "Please review the highlighted fields." }) => {
  if (success) {
    return <div className="epic-form-feedback success"><strong>{success}</strong></div>;
  }

  if (validationErrors.length > 0) {
    return (
      <div className="epic-form-feedback error">
        <strong>{title}</strong>
        <ul>
          {validationErrors.slice(0, 5).map((message, index) => (
            <li key={`${index}-${message}`}>{message}</li>
          ))}
        </ul>
      </div>
    );
  }

  if (error) {
    return <div className="epic-form-feedback error"><strong>{error}</strong></div>;
  }

  return null;
};

export default FormFeedback;
